/* Packages */
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';

/* Hooks */
import useValidation from '../hooks/useValidation';
import useFlowContext from "../hooks/useFlowContext";

const dateDisplayFormat = "dd-MM-yyyy"
const dateBackendFormat = "yyyy-MM-dd"

export default function FlowFieldDatePicker(props) {
    const { colClassName, field, path, id, updateValue } = props;
    const { type, label, required, disabled, placeholder = null, value, name, minDate, maxDate, disabledDays = [] } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });


    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const resolveDateValue = (value) => {
        if (value && !(value instanceof Date)) {
            return new Date(value);
        }

        return value;
    };

    const filterDate = (date) => {
        const day = date?.getDay();
        return !disabledDays?.includes(day);
    }

    const {
        translate = () => {},
    } = useFlowContext();

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                <DatePicker
                    className={`form-control ${error ? 'is-error' : ''}`}
                    selected={resolveDateValue(value)}
                    minDate={minDate ? new Date(minDate) : null}
                    maxDate={maxDate ? new Date(maxDate) : null}
                    placeholderText={placeholder}
                    id={id}
                    name={id}
                    dateFormat={dateDisplayFormat}
                    {...{
                        type,
                        required,
                        disabled,
                    }}
                    filterDate={filterDate}
                    onChange={(date) => {
                        updateValue(format(date, dateBackendFormat), () => {
                            trigger(path);
                        });
                    }}
                />

                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
